import * as React from 'react';

import { enumUnit } from '@rematter/frontend-lib-api-client';
import { enumLoadWeightType } from '@rematter/modules/trade/types/load';
import Big from 'big.js';

import { RemainingWeightButtonCellProps } from '../types';

import { RemainingWeightButton } from './RemainingWeightButton';

export interface ExtendedRemainingWeightButtonCellProps extends RemainingWeightButtonCellProps {
  isSalesOrderLoad?: boolean;
}

export const RemainingWeightButtonCell: React.FC<
  ExtendedRemainingWeightButtonCellProps
> = ({
  lineItem,
  disabled = false,
  onUpdateLineItem,
  onChangeRequestedQuantity,
  isSalesOrderLoad = false,
}) => {
  const handleClick = React.useCallback(() => {
    const amount = new Big(
      lineItem.weights?.[enumLoadWeightType.QuantityOwed]?.value ?? 0,
    ).toNumber();

    if (isSalesOrderLoad && onChangeRequestedQuantity) {
      onChangeRequestedQuantity(lineItem.id, amount);
    } else {
      onUpdateLineItem(lineItem.id, {
        weights: {
          ...lineItem.weights,
          [enumLoadWeightType.Net]: {
            value: amount,
            unit:
              lineItem.weights?.[enumLoadWeightType.Net]?.unit ||
              enumUnit.Pounds,
            __typename: 'Weight' as const,
          },
        },
      });
    }
  }, [lineItem, onUpdateLineItem, isSalesOrderLoad, onChangeRequestedQuantity]);

  const isDisabled = React.useMemo(
    () => disabled || lineItem.type === 'Tagged',
    [disabled, lineItem.type],
  );

  return (
    <RemainingWeightButton
      onPress={handleClick}
      isDisabled={isDisabled}
      className="@RemainingWeightButtonCell"
    />
  );
};
